import type { JSX } from 'react';

import { ThemeProvider } from '@change/ds-core-ui/next';

import { PageBody } from '../components/PageBody';
import { PageHeader } from '../components/PageHeader';

import { useTrackPageView } from './hooks/useTrackPageView';

export function Layout(): JSX.Element {
	useTrackPageView();

	return (
		<ThemeProvider>
			<PageHeader />
			<div className="bg-fill-weaker h-full w-full">
				<PageBody />
			</div>
			<div className="bg- bg-background-base sm:col-span-12 sm:block md:hidden">Bottom navigation</div>
		</ThemeProvider>
	);
}
